import { useTranslation } from 'react-i18next';

import { ConfirmModal } from '@/components/feedback/ConfirmModal';

interface DiscardChangesModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DiscardChangesModal({ open, onConfirm, onCancel }: DiscardChangesModalProps) {
  const { t } = useTranslation('roles');
  return (
    <ConfirmModal
      open={open}
      title={t('modals.discardChanges.title')}
      message={t('modals.discardChanges.message')}
      confirmLabel={t('actions.leave')}
      cancelLabel={t('actions.cancel')}
      confirmVariant="destructive"
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
